var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Provides a unified checkbox/switch component used throughout the
 * claims journey. It automatically displays either a UiCheckbox or a UiSwitch
 * depending on insurer feature flags while exposing a single boolean v-model.
 * touches: insurer feature flags controlling claims check rendering
 * invariants: emits a boolean through the 'update' event; rendered control is
 * determined by ClaimsCheckModeIsSwitch feature flag, otherwise falls back to
 * the displayMode prop; translated label always comes from tradKey.
 * inputs: tradKey, isChecked, displayMode props; ClaimsCheckModeIsSwitch feature flag.
 * outputs: emits 'update' with the new checked state.
 * see: frontend/src/shared/featureFlags/insurerFeatureFlags.ts
 */
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { UiSwitch, UiCheckbox } from '@claims-ia/design-system';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
let ClaimsCheck = class ClaimsCheck extends Vue {
    get localChecked() {
        var _a;
        return (_a = this.isChecked) !== null && _a !== void 0 ? _a : false;
    }
    set localChecked(value) {
        this.$emit('update', value);
    }
    get mode() {
        return insurerHasFeature(InsurerFeatureFlag.ClaimsCheckModeIsSwitch)
            ? 'switch'
            : this.displayMode;
    }
    handleCheckedState(isChecked) {
        this.localChecked = isChecked;
    }
};
ClaimsCheck = __decorate([
    Component({
        name: 'ClaimsCheck',
        components: { UiSwitch, UiCheckbox },
        props: {
            displayMode: {
                type: String,
                default: 'checkbox',
            },
            tradKey: {
                type: String,
                required: true,
            },
            isChecked: {
                type: Boolean,
                default: false,
            },
        },
        model: {
            prop: 'isChecked',
            event: 'update',
        },
    })
], ClaimsCheck);
export default ClaimsCheck;
